import { ClaimCounter } from '@recruitee/http/types';
import { createSingleEntityStore } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<{
  counters: ClaimCounter[];
}>()('ReferralsClaimCounters');

export {
  actions as ReferralsClaimCounterActions,
  reducer as ReferralsClaimCounterReducer,
  selectors as ReferralsClaimCounterSelectors,
  namespace as ReferralsClaimCounterNamespace,
};
